import api, { getErrorMessage } from './api';

const walletService = {
  /**
   * Get current user's wallet balance
   * @returns {Promise<object>} - Wallet data with balance
   */
  getMyWallet: async () => {
    try {
      const response = await api.get('/api/v1/wallet/me');
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Get current user's transaction history
   * @param {number} skip - Number of records to skip
   * @param {number} limit - Number of records to return
   * @returns {Promise<Array>} - Transaction history
   */
  getMyTransactions: async (skip = 0, limit = 100) => {
    try {
      const response = await api.get('/api/v1/wallet/me/transactions', {
        params: { skip, limit },
      });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },

  /**
   * Manually adjust user points (admin only)
   * @param {string} userId - User ID
   * @param {object} adjustmentData - Adjustment data
   * @param {number} adjustmentData.amount - Amount to adjust (positive or negative)
   * @param {string} adjustmentData.reason - Reason for adjustment
   * @returns {Promise<object>} - Updated wallet
   */
  adjustUserPoints: async (userId, adjustmentData) => {
    try {
      // Backend expects query parameters, not request body
      const response = await api.post(`/api/v1/wallet/admin/adjust/${userId}`, null, {
        params: {
          amount: adjustmentData.amount,
          reason: adjustmentData.reason,
        },
      });
      return response.data;
    } catch (error) {
      throw new Error(getErrorMessage(error));
    }
  },
};

export default walletService;
